export const createHiddenItemsFields = itemsToSave => {
  const modalWidget = document.getElementById('headerWrapper');
  itemsToSave.forEach((item, i) => {
    const idx = i + 1;
    const orderItemForSavedListInput = document.createElement('input');
    if (orderItemForSavedListInput) {
      orderItemForSavedListInput.type = 'hidden';
      orderItemForSavedListInput.id = `orderItemForSavedList_${idx}`;
      orderItemForSavedListInput.value = item.orderItemId;
      modalWidget.append(orderItemForSavedListInput);
    }

    const partNumberForSavedListInput = document.createElement('input');
    if (partNumberForSavedListInput) {
      partNumberForSavedListInput.type = 'hidden';
      partNumberForSavedListInput.id = `partNumberForSavedList_${item.orderItemId}`;
      partNumberForSavedListInput.value = item.partNumber;
      modalWidget.append(partNumberForSavedListInput);
    }

    const qtyForSavedListInput = document.createElement('input');
    if (qtyForSavedListInput) {
      qtyForSavedListInput.id = `qtyForSavedList_${item.orderItemId}`;
      qtyForSavedListInput.type = 'hidden';
      qtyForSavedListInput.value = item.quantity;
      modalWidget.append(qtyForSavedListInput);
    }

    const selfServiceOptionIdInput = document.createElement('input');
    if (selfServiceOptionIdInput) {
      selfServiceOptionIdInput.id = `selfServiceOptionId_${item.orderItemId}`;
      selfServiceOptionIdInput.type = 'hidden';
      selfServiceOptionIdInput.value =
        item.orderItemExtendAttribute.ssroBundle?.[0]?.selfServiceOptionId ||
        '';
      modalWidget.append(selfServiceOptionIdInput);
    }

    const selfServiceOptionNameInput = document.createElement('input');
    if (selfServiceOptionNameInput) {
      selfServiceOptionNameInput.id = `selfServiceOptionName_${item.orderItemId}`;
      selfServiceOptionNameInput.type = 'hidden';
      selfServiceOptionNameInput.value =
        item.orderItemExtendAttribute.ssroBundle?.[0]?.selfServiceOptionName ||
        '';
      modalWidget.append(selfServiceOptionNameInput);
    }

    // TODO: This is going to be handled in an upcoming story with a WCS adjusment as well
    // const selfSvcOptionInstructionLinkInput = document.createElement('input');
    // selfSvcOptionInstructionLinkInput.id = `selfServiceOptionInstructionLink_${item.orderItemId}`;
    // selfSvcOptionInstructionLinkInput.type = 'hidden';
    // selfSvcOptionInstructionLinkInput.value =
    //   item.orderItemExtendAttribute.selfServiceOptionInstructionLink;

    // TODO: This is going to be handled in an upcoming story with a WCS adjusment as well
    // const selfServiceOptionSerialNumberInput = document.createElement('input');
    // selfServiceOptionSerialNumberInput.id = `selfServiceOptionSerialNumber_${item.orderItemId}`;
    // selfServiceOptionSerialNumberInput.type = 'hidden';
    // selfServiceOptionSerialNumberInput.value = item.equipment.serialNumber;

    // TODO: This is going to be handled in an upcoming story with a WCS adjusment as well
    // const selfServiceOptionSalesModelInput = document.createElement('input');
    // selfServiceOptionSalesModelInput.id = `selfServiceOptionSalesModel_${item.orderItemId}`;
    // selfServiceOptionSalesModelInput.type = 'hidden';
    // selfServiceOptionSalesModelInput.value = 'no clue';

    // TODO: This is going to be handled in an upcoming story with a WCS adjusment as well
    // modalWidget.append(selfSvcOptionInstructionLinkInput);
    // modalWidget.append(selfServiceOptionSerialNumberInput);
    // modalWidget.append(selfServiceOptionSalesModelInput);
  });
};
